import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

async function fetchAdminRole(userId: string): Promise<boolean> {
  const { data, error } = await supabase
    .from("user_roles")
    .select("role")
    .eq("user_id", userId)
    .eq("role", "admin")
    .maybeSingle();

  if (error) {
    console.error("Error checking admin role:", error);
    return false;
  }
  return !!data;
}

export function useAdminCheck() {
  const { user, loading: authLoading } = useAuth();

  const { data: isAdmin = false, isLoading: roleLoading } = useQuery({
    queryKey: ["admin-check", user?.id],
    queryFn: () => fetchAdminRole(user!.id),
    enabled: !!user?.id,
    staleTime: 10 * 60 * 1000,
  });

  return { isAdmin, loading: roleLoading || authLoading };
}
